import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import type { Manager } from '../manager'

export const clearCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.clear.observe().pipe(
      rxjs.map(({ data: { chartId: orgChartId } }) => {
        const cy = manager.getInstance({ chartId: orgChartId })
        if (!cy) {
          return
        }
        cy.remove('*')
      }),
      rxjs.ignoreElements(),
    ),
)
